import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmNgSelectComponent } from './sm-ng-select.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SmErrorModule } from '../sm-error/sm-error.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [SmNgSelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    NgbModule,
    SmErrorModule
  ],
  exports:[SmNgSelectComponent]
})
export class SmNgSelectModule { }
